import { render, staticRenderFns } from "./PromoConfigForm.vue?vue&type=template&id=002d866a&scoped=true"
import script from "./PromoConfigForm.vue?vue&type=script&lang=js"
export * from "./PromoConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d866a",
  null
  
)

export default component.exports